'use client';
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ReactImageGalleryItem } from 'react-image-gallery';

import classes from './style.module.scss';

const Thumbnails = ({
    images,
    activeImage,
    setActiveImage,
    fireEvent,
    refs,
    containerClass,
    thumbnailClass = undefined,
}: {
    images: ReactImageGalleryItem[];
    activeImage: number;
    setActiveImage: any;
    fireEvent: () => void;
    refs: any;
    containerClass: string;
    thumbnailClass?: string;
}) => {
    const handleThumbnailClick = (index: number) => {
        fireEvent();
        setActiveImage(index);

        // @ts-ignore
        refs?.current?.[index]?.current?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
    };

    return (
        <div className={containerClass}>
            {images?.map(({ thumbnail }, index) => {
                return (
                    <img
                        loading="lazy"
                        className={`${classes.thumbnail} ${thumbnailClass} ${
                            index === activeImage ? classes.thumbnailActive : ''
                        }`}
                        ref={refs?.current?.[index]}
                        src={thumbnail as string}
                        alt="Car image thumbnail"
                        key={thumbnail ?? '' + index}
                        // width={100}
                        // height={100}
                        onClick={() => {
                            handleThumbnailClick(index);
                        }}
                    />
                );
            })}
        </div>
    );
};
export default Thumbnails;
